import React from "react";
import { RAIL_WIDTH_MOBILE } from "../sideMenuDensity";

type SideMenuMobileShellProps = {
  isOpen: boolean;
  onBackdropClick: () => void;
  children: React.ReactNode;
};

const SideMenuMobileShell: React.FC<SideMenuMobileShellProps> = ({
  isOpen,
  onBackdropClick,
  children,
}) => (
  <>
    {/* Above the floating Archi dock and panel (z-50), which otherwise sat on
        the open drawer and hid its footer; below modals (z-[9999]). `z-80`
        was not a Tailwind class, so the backdrop had no z-index at all. */}
    {isOpen && (
      <div
        className="
          fixed inset-0 bg-black/50 z-[60]
          transition-opacity duration-300
        "
        onClick={onBackdropClick}
        role="presentation"
      />
    )}
    {/* inset-y-0, not h-screen: on mobile browsers 100vh includes the area
        behind the address/tool bar, which pushed the footer (Technical
        Support) off screen (CTX-1339). A fixed box pinned to top and bottom
        follows the visible viewport instead. */}
    <div
      className={`
        mobile-menu-drawer
        fixed inset-y-0 left-0 z-[70]
        ${RAIL_WIDTH_MOBILE}
        bg-semantic-bg-primary
        text-gray-700
        border-r border-semantic-border-primary
        flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
      `}
    >
      {children}
    </div>
  </>
);

export default SideMenuMobileShell;
